import React, { useState, useEffect } from 'react'
import DashboardSidebar from '../../Containers/DashboardSidebar'
import { Switch, Route, Redirect, withRouter } from 'react-router'
// import StatsOverview from '../../Containers/StatsOverview'
import StatsCityPlan from '../../Containers/StatsCityPlan'
import PivotTables from '../../Containers/StatsPivotTables'
import StatsDeliverability from '../StatsDeliverability'
import { getDashboardCityPlans } from './util'
import LoadingIndicator from '../../Components/LoadingIndicator/LoadingIndicator'
import { getCampaignByChunks } from '../../Module/graphQL'
import { gqlCampaign, gqlCityPlans, gqlMissions } from './gql'
import { MISSION_STATUS_ENUM } from '../../shared/constants'
import { CONFIG } from '../../Config/config'

const StatsDashboard = ({ campaignId, path, match }) => {
  const [isLoading, setIsLoading] = useState(true)
  const [campaign, setCampaign] = useState({})
  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    setIsLoading(true)
    try {
      const res = await getCampaignByChunks({
        campaignId,
        cityPlanChunk: 1,
        missionChunk: 50,
        missionStatuses: [
          MISSION_STATUS_ENUM.UNDER_REVIEW,
          MISSION_STATUS_ENUM.COMPLETED,
          MISSION_STATUS_ENUM.PAID,
        ],
        queries: { gqlCampaign, gqlCityPlans, gqlMissions },
      })

      setCampaign(res)
    } catch (e) {
      setCampaign(null)
      throw e
    } finally {
      setIsLoading(false)
    }
  }

  if (isLoading) return <LoadingIndicator style={{ marginTop: 50 }} />

  return (
    <div>
      <DashboardSidebar
        cityPlans={getDashboardCityPlans(campaign.cityPlans.nodes)}
        campaignId={campaignId}
        campaignType={campaign.type}
        basePath={match.url}
        path={path}
        countryCode={campaign.country.code}
      >
        <Switch>
          {/* This is the old dashboard */}
          {/* <Route
            path={match.url + '/overview'}
            exact
            render={props => (
              <StatsOverview
                {...props}
                campaignResults={campaign}
                campaignId={campaignId}
              />
            )}
          /> */}
          {/* This is the new dashboard */}
          <Route
            path={match.url + '/overview'}
            exact
            render={() => {
              const campaignId = window.location.href.split('/').slice(-3)[0]
              window.location.href = `${
                CONFIG.NEXT_BASE_URL
              }/dashboard/campaigns/${campaignId}/dashboard/overview`
            }}
          />
          <Route
            path={match.url + '/city-plan/:cityPlanId'}
            render={({ match, ...otherProps }) => (
              <StatsCityPlan
                {...otherProps}
                campaignId={campaignId}
                cityPlanId={match.params.cityPlanId}
                campaignResults={campaign}
              />
            )}
          />
          <Route
            path={match.url + '/pivot-tables'}
            exact
            render={props => (
              <PivotTables
                {...props}
                campaignResults={campaign}
                campaignId={campaignId}
              />
            )}
          />
          <Route
            path={match.url + '/deliverability'}
            exact
            render={props => (
              <StatsDeliverability
                {...props}
                campaignResults={campaign}
                campaignId={campaignId}
              />
            )}
          />
          <Redirect to={match.url + '/overview'} />
        </Switch>
      </DashboardSidebar>
    </div>
  )
}

export default withRouter(StatsDashboard)
